var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(-1 0 0 1 2638.213 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2294.857,
    x2: 2356.202,
    y1: 144.489,
    y2: 277.403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-1 0 0 1 2638.213 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2482.363,
    x2: 2317.396,
    xlinkHref: "#lg1",
    y1: 207.541,
    y2: 207.541
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.64,
    x2: 104.391,
    xlinkHref: "#lg1",
    y1: 315.289,
    y2: 160.079
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-1 0 0 1 2638.213 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2330.926,
    x2: 2330.926,
    xlinkHref: "#lg2",
    y1: 181.848,
    y2: 243.132
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(-1 0 0 1 2638.213 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2332.376,
    x2: 2335.377,
    xlinkHref: "#lg3",
    y1: 244.017,
    y2: 166.763
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-1 0 0 1 2638.213 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2330.926,
    x2: 2330.926,
    xlinkHref: "#lg3",
    y1: 225.546,
    y2: 182.672
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-1 0 0 1 2638.213 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2331.31,
    x2: 2332.104,
    xlinkHref: "#lg3",
    y1: 204.52,
    y2: 177.533
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(-1 0 0 1 2638.213 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2483.658,
    x2: 2250.372,
    xlinkHref: "#lg3",
    y1: 207.54,
    y2: 207.54
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.962,
    x2: 307.962,
    xlinkHref: "#lg4",
    y1: 381.043,
    y2: 449.063
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.962,
    x2: 307.962,
    xlinkHref: "#lg4",
    y1: 387.845,
    y2: 418.17
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.434,
    x2: 156.434,
    xlinkHref: "#lg5",
    y1: 402.995,
    y2: 426.525
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.58,
    x2: 218.58,
    xlinkHref: "#lg5",
    y1: 402.995,
    y2: 426.525
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.956,
    x2: 300.956,
    y1: 412.579,
    y2: 351.979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.295,
    x2: 389.805,
    xlinkHref: "#lg4",
    y1: 350.012,
    y2: 459.451
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.009,
    x2: 370.009,
    xlinkHref: "#lg2",
    y1: 375.769,
    y2: 437.054
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.504,
    x2: 374.166,
    xlinkHref: "#lg3",
    y1: 436.793,
    y2: 368.27
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.009,
    x2: 370.009,
    xlinkHref: "#lg3",
    y1: 419.467,
    y2: 376.594
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.378,
    x2: 371.136,
    xlinkHref: "#lg3",
    y1: 398.991,
    y2: 373.193
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a98f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(0 1 -1 0 3041.312 182.186)",
    gradientUnits: "userSpaceOnUse",
    x1: 73.866,
    x2: 193.824,
    xlinkHref: "#lg6",
    y1: 2726.65,
    y2: 2726.65
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(0 1 -1 0 3041.312 182.186)",
    gradientUnits: "userSpaceOnUse",
    x1: 91.501,
    x2: 136.836,
    xlinkHref: "#lg6",
    y1: 2726.65,
    y2: 2726.65
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(0 1 -1 0 3041.312 182.186)",
    gradientUnits: "userSpaceOnUse",
    x1: 73.866,
    x2: 145.146,
    xlinkHref: "#lg4",
    y1: 2586.321,
    y2: 2586.321
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(0 1 -1 0 3041.312 182.186)",
    gradientUnits: "userSpaceOnUse",
    x1: 73.866,
    x2: 145.146,
    xlinkHref: "#lg4",
    y1: 2617.033,
    y2: 2617.033
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(0 1 -1 0 3041.312 182.186)",
    gradientUnits: "userSpaceOnUse",
    x1: 73.866,
    x2: 145.146,
    xlinkHref: "#lg4",
    y1: 2836.267,
    y2: 2836.267
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(0 1 -1 0 3041.312 182.186)",
    gradientUnits: "userSpaceOnUse",
    x1: 73.866,
    x2: 145.146,
    xlinkHref: "#lg4",
    y1: 2866.979,
    y2: 2866.979
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(0 1 -1 0 3041.312 182.186)",
    gradientUnits: "userSpaceOnUse",
    x1: 81.07,
    x2: -29.503,
    y1: 2711.247,
    y2: 2659.691
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.242,
    x2: 94.66,
    xlinkHref: "#lg3",
    y1: 247.427,
    y2: 165.803
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(.968 .251 -.251 .968 76.91 -73.121)",
    gradientUnits: "userSpaceOnUse",
    x1: 49.38,
    x2: 169.339,
    xlinkHref: "#lg5",
    y1: 313.6,
    y2: 313.6
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(.968 .251 -.251 .968 76.91 -73.121)",
    gradientUnits: "userSpaceOnUse",
    x1: 67.016,
    x2: 112.35,
    xlinkHref: "#lg5",
    y1: 313.6,
    y2: 313.6
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(.968 .251 -.251 .968 76.91 -73.121)",
    gradientUnits: "userSpaceOnUse",
    x1: 49.38,
    x2: 120.66,
    xlinkHref: "#lg2",
    y1: 173.27,
    y2: 173.27
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(.968 .251 -.251 .968 76.91 -73.121)",
    gradientUnits: "userSpaceOnUse",
    x1: 49.38,
    x2: 120.66,
    xlinkHref: "#lg2",
    y1: 453.929,
    y2: 453.929
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientTransform: "matrix(.968 .251 -.251 .968 76.91 -73.121)",
    gradientUnits: "userSpaceOnUse",
    x1: 49.38,
    x2: 120.66,
    xlinkHref: "#lg2",
    y1: 423.053,
    y2: 423.053
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(.968 .251 -.251 .968 76.91 -73.121)",
    gradientUnits: "userSpaceOnUse",
    x1: 85.363,
    x2: 2.942,
    y1: 315.606,
    y2: 294.238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m130.739 174.565v65.951c0 8.58 6.955 15.535 15.535 15.535h314.851c13.394 0 25.526-5.429 34.307-14.21s14.21-20.913 14.21-34.307c0-26.788-21.717-48.505-48.517-48.505h-314.851c-8.58.001-15.535 6.956-15.535 15.536z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m146.274 159.03h122.325c-8.58 0-15.535 6.955-15.535 15.535v65.951c0 8.58 6.955 15.535 15.535 15.535h-122.325c-8.58 0-15.535-6.955-15.535-15.535v-65.951c0-8.58 6.955-15.535 15.535-15.535z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m146.274 256.052h119.301l-.388-.388c-5.837-1.31-10.425-5.898-11.735-11.735l-84.899-84.899h-22.279c-8.58 0-15.535 6.955-15.535 15.535v65.951c0 8.58 6.955 15.536 15.535 15.536z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m136.295 244.297h321.579c20.3 0 36.757-16.456 36.757-36.757 0-20.3-16.456-36.757-36.757-36.757h-323.645c-7.889 0-14.284 6.395-14.284 14.284v42.879c-.001 9.031 7.32 16.351 16.35 16.351z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m490.368 224.721c-6.168 11.641-18.402 19.576-32.494 19.576h-321.579c-9.03 0-16.35-7.32-16.35-16.35v-3.226z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m457.874 244.297h-321.579c-9.03 0-16.35-7.32-16.35-16.35v-20.407h374.685c0 20.3-16.456 36.757-36.756 36.757z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m490.548 190.711c2.603 5.044 4.082 10.762 4.082 16.829 0 20.3-16.456 36.757-36.757 36.757h-321.578c-9.03 0-16.35-7.32-16.35-16.35v-37.236z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m133.965 170.784h119.582c-.304 1.213-.483 2.475-.483 3.781v65.951c0 1.306.179 2.568.482 3.78h-117.514c-9.03 0-16.35-7.32-16.35-16.35v-42.879c-.001-7.888 6.394-14.283 14.283-14.283z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m496.601 367.612v67.711c0 7.878-6.246 14.297-14.062 14.569-.087 0-.173.012-.272.012-.087 0-.173.012-.26.012h-329.403c-12.726 0-23.782-7.136-29.372-17.636-2.498-4.675-3.908-10.005-3.908-15.657v-30.325c0-5.652 1.41-10.982 3.908-15.645.73-1.398 1.583-2.746 2.511-4.007 6.06-8.261 15.83-13.629 26.862-13.629h329.404c8.062.001 14.592 6.531 14.592 14.595z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m496.601 370.654v61.626h-373.37c-2.498-4.675-3.908-10.005-3.908-15.657v-30.325c0-5.652 1.41-10.982 3.908-15.645h373.37z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m149.267 432.28c-2.498-4.675-3.908-10.005-3.908-15.657v-30.325c0-5.652 1.41-10.982 3.908-15.645.73-1.398 1.583-2.746 2.511-4.007 6.06-8.261 15.83-13.629 26.862-13.629h-11.131c-11.032 0-20.802 5.367-26.862 13.629-.928 1.262-1.781 2.609-2.511 4.007-2.498 4.663-3.908 9.993-3.908 15.645v30.325c0 5.652 1.41 10.982 3.908 15.657 5.59 10.5 16.647 17.636 29.372 17.636h11.131c-12.726 0-23.782-7.136-29.372-17.636z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m211.413 432.28c-2.498-4.675-3.908-10.005-3.908-15.657v-30.325c0-5.652 1.41-10.982 3.908-15.645.73-1.398 1.583-2.746 2.511-4.007 6.06-8.261 15.83-13.629 26.862-13.629h-11.131c-11.032 0-20.802 5.367-26.862 13.629-.928 1.262-1.781 2.609-2.511 4.007-2.498 4.663-3.908 9.993-3.908 15.645v30.325c0 5.652 1.41 10.982 3.908 15.657 5.59 10.5 16.647 17.636 29.372 17.636h11.131c-12.726 0-23.782-7.136-29.372-17.636z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m482.589 381.24v67.711c0 .322-.025.618-.05.94-.087 0-.173.012-.272.012-.087 0-.173.012-.26.012h-329.403c-12.726 0-23.782-7.136-29.372-17.636-2.498-4.675-3.908-10.005-3.908-15.657v-30.325c0-5.652 1.41-10.982 3.908-15.645.73-1.398 1.583-2.746 2.511-4.007h342.254c3.896 0 7.42 1.521 10.03 4.007 2.818 2.649 4.562 6.421 4.562 10.588z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m498.942 368.487v65.951c0 8.58-6.955 15.535-15.535 15.535h-219.621c-13.394 0-25.526-5.429-34.307-14.21s-14.21-20.913-14.21-34.307c0-26.788 21.717-48.505 48.517-48.505h219.621c8.58.001 15.535 6.956 15.535 15.536z",
    fill: "url(#SVGID_14_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m493.386 438.219h-226.349c-20.3 0-36.757-16.456-36.757-36.757 0-20.3 16.456-36.757 36.757-36.757h228.415c7.889 0 14.284 6.395 14.284 14.284v42.879c.001 9.03-7.32 16.351-16.35 16.351z",
    fill: "url(#SVGID_15_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m234.543 418.643c6.168 11.642 18.402 19.576 32.494 19.576h226.349c9.03 0 16.35-7.32 16.35-16.35v-3.226z",
    fill: "url(#SVGID_16_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m267.037 438.219h226.349c9.03 0 16.35-7.32 16.35-16.35v-20.406h-279.455c0 20.299 16.456 36.756 36.756 36.756z",
    fill: "url(#SVGID_17_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m234.363 384.633c-2.603 5.044-4.082 10.762-4.082 16.829 0 20.3 16.456 36.757 36.757 36.757h226.349c9.03 0 16.35-7.32 16.35-16.35v-37.236z",
    fill: "url(#SVGID_18_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m119.323 338.357v-67.711c0-8.06 6.534-14.594 14.594-14.594h361.488c8.06 0 14.594 6.534 14.594 14.594v67.711c0 8.06-6.534 14.594-14.594 14.594h-361.488c-8.06.001-14.594-6.533-14.594-14.594z",
    fill: "url(#SVGID_19_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m119.323 335.316v-61.629h390.677v61.629z",
    fill: "url(#SVGID_20_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m448.586 352.952v-96.9h12.81v96.9z",
    fill: "url(#SVGID_21_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m417.874 352.952v-96.9h12.81v96.9z",
    fill: "url(#SVGID_22_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m198.639 352.952v-96.9h12.811v96.9z",
    fill: "url(#SVGID_23_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m167.927 352.952v-96.9h12.81v96.9z",
    fill: "url(#SVGID_24_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m495.987 284.28c0-8.06-6.534-14.594-14.594-14.594h-361.488c-.18 0-.356.02-.535.027-.02.31-.047.618-.047.934v67.712c0 8.06 6.534 14.594 14.594 14.594h361.488c.18 0 .356-.02.535-.027.02-.31.047-.618.047-.934z",
    fill: "url(#SVGID_25_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m131.133 171.13c-.25 1.107-.394 2.253-.394 3.435v65.951c0 .99.103 1.955.279 2.894 1.657.566 3.427.886 5.276.886h117.254c-.031-.123-.069-.244-.097-.368l-73.145-73.145h-46.078c-1.064.001-2.097.126-3.095.347z",
    fill: "url(#SVGID_26_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m76.468 452.578-65.538-17.017c-7.802-2.026-12.484-9.992-10.458-17.794l90.846-349.886c2.026-7.802 9.992-12.484 17.794-10.458l65.538 17.017c7.802 2.026 12.484 9.992 10.458 17.794l-90.846 349.885c-2.026 7.802-9.992 12.484-17.794 10.459z",
    fill: "url(#SVGID_27_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m73.525 451.813-59.651-15.488 98.181-378.138 59.651 15.488z",
    fill: "url(#SVGID_28_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m173.342 137.55-93.791-24.352 3.22-12.399 93.79 24.352z",
    fill: "url(#SVGID_29_)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m102.809 409.201-93.79-24.352 3.219-12.399 93.79 24.352z",
    fill: "url(#SVGID_30_)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m110.569 379.316-93.791-24.352 3.22-12.399 93.79 24.352z",
    fill: "url(#SVGID_31_)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m118.786 74.411c-7.802-2.026-15.768 2.657-17.794 10.458l-90.845 349.888c-.045.175-.07.349-.108.524.295.097.587.201.892.28l65.538 17.017c7.801 2.026 15.768-2.657 17.794-10.458l90.846-349.887c.045-.175.07-.349.108-.524-.295-.097-.587-.201-.892-.28z",
    fill: "url(#SVGID_32_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBooks);
export default __webpack_public_path__ + "static/media/icon-books.4824df288be85039682e603daa2d7940.svg";
export { ForwardRef as ReactComponent };